import React from "react";

import Context from "../../../context/Context";
import { ModalController } from "../../../common/components/Modal";
import OfficePlan from "../../base/OfficePlan";
import Topic from "../../../context/Topic";
import * as component from "../../../components/util/component";

import { Formik, Field } from "formik";

import Form, { FormControl, FormControlLabel } from "calcite-react/Form";
import TextField from "calcite-react/TextField";

export default class AddArea extends React.Component {
  componentId;

  constructor(props) {
    super(props);
    this.componentId = component.nextId();
    this.state = component.newState({
      name: ""
    });
    this.onChangeName = this.onChangeName.bind(this);
  }

  componentDidMount() {}

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  onChangeName(evt) {
    const v = evt.target.value;
    this.setState({ name: v });
    if (this.props.onChange) {
      this.props.onChange({ name: v });
    }
  }

  onValidate = values => {
    const errors = {};

    if (!values.name || values.name.trim().length === 0) {
      errors.name = true;
    }

    return errors;
  };

  render() {
    const i18n = Context.instance.i18n;
    const id = this.componentId;
    const horizontal = false;
    const cls = horizontal ? "i--form i--form-horizontal" : "i--form";

    // Formik value object
    const form = {
      name: this.state.name
    };

    return (
      <Formik
        initialValues={form}
        validate={this.onValidate}
        onSubmit={this.props.submitHandle}
      >
        {({ values, errors, touched, handleSubmit, isSubmitting }) => (
          <Form className={cls} onSubmit={handleSubmit}>
            <FormControl horizontal={horizontal}>
              <FormControlLabel
                id={id + "-name-label"}
                htmlFor="name"
                className="i--form-label"
              >
                <span className="i--required">
                  {i18n.spaceplanner.areaProperties.name}
                </span>
              </FormControlLabel>

              <Field
                component={TextField}
                id={id + "-name"}
                name="name"
                fullWidth={true}
                autoFocus
                onChange={this.onChangeName}
              />
            </FormControl>
          </Form>
        )}
      </Formik>
    );
  }

  static showModal(props) {
    let controller,
      areaName = "",
      adding = false;
    const i18n = Context.instance.i18n;
    const plan = Context.instance.spaceplanner.activePlan;
    const areasTable = plan && plan.areasTable;
    const areaType = props.areaType;

    const onChange = obj => {
      areaName = obj.name.trim();
    };

    const onOK = obj => {
      //console.log("areaName",typeof areaName,areaName.length,areaName)
      if (!adding && areaName.length > 0) {
        adding = true;
        areasTable
          .addArea(areaName, areaType)
          .then(result => {
            Topic.publish(Topic.PlanModified, {
              action: OfficePlan.Action_AssignmentsUpdated
            });
            controller.close();
          })
          .catch(error => {
            console.error("Error adding area", error);
            controller.close();
            Topic.publishErrorUpdatingData(error.submessage);
          });
      }
    };

    const modalProps = {
      dialogStyle: { width: "35vw" },
      title: props.caption,
      showOKCancel: true,
      closeOnOK: false,
      onOK: onOK,
      okLabel: i18n.spaceplanner.areaProperties.add
    };

    if (plan && plan.wasOpened && plan.isAreasTableValid() && areasTable) {
      const content = (
        <AddArea {...props} onChange={onChange} submitHandle={onOK} />
      );
      controller = new ModalController({});
      controller.show(modalProps, content);
    }
  }
}
